import style from './Right.module.scss';

import { SelectButtonMenu } from '@components/SelectButtonMenu';

import { useEntryTypeHeaderActions } from './hooks/useEntryTypeHeaderActions';

export interface RightParams {
    entryTypeId: string;
    version: number;
}

export function Right({ entryTypeId, version }: RightParams) {
    const { title, items, onClick } = useEntryTypeHeaderActions({ entryTypeId, version });

    return (
        <div className={style.root}>
            <div className={style.button}>
                <SelectButtonMenu
                    title={title}
                    items={items}
                    onButtonClick={onClick}
                />
            </div>
        </div>
    );
}
